module.exports = __webpack_public_path__ + "svg/profile-icon.svg?778d67927051cf0a2df8b59bd5de1085";